import { useContext, useEffect } from 'react';
import { Button } from 'react-bootstrap';
import { useHistory } from 'react-router';

import { OnboardingContext } from '../../context/OnboardingContext';
import { useSetUserDetails } from '../../hooks';
import LoopSpinner from '../../ui/LoopSpinner';

const FinalisingContainer = () => {
  const history = useHistory();
  const { triggerSetUserDetails, requestError } = useSetUserDetails();
  const { setProgressPercentage } = useContext(OnboardingContext);

  useEffect(() => {
    const asyncUseEffect = async () => {
      await triggerSetUserDetails();
      setProgressPercentage(0);
    };
    void asyncUseEffect();
  }, [triggerSetUserDetails, setProgressPercentage]);

  return (
    <>
      <h1 className="mb-3">Finalising</h1>
      {!requestError ? (
        <>
          <div className="mt-1 mb-4">
            <LoopSpinner />
          </div>
          <p className="mb-0">Please wait a moment while we finish setting up your account.</p>
          <Button disabled={true} onClick={() => history.push('/onboarding/finalising')}>
            Continue
          </Button>
        </>
      ) : (
        <p className="mb-0">
          We encountered an error and were not able to complete your onboarding. Please try again and contact us if the
          problem persists.
        </p>
      )}
    </>
  );
};

export default FinalisingContainer;
